import {EditorView} from "prosemirror-view";
import {EditorState, TextSelection, Transaction} from "prosemirror-state";
import intl from "react-intl-universal";

import {TriggerActionCommandAdditionalParams} from "./types";


import {replaceSelectionParagraphWithNode, replaceTextRangeWithNode} from "./utils";


import {schema} from "../../config/schema";


export const insertHeading = (level: number) => {
    return (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: TriggerActionCommandAdditionalParams) => {
        const defaultText = intl.get('insertHeading.dump_heading').d('Heading');
        const node = schema.nodes.heading.create({level}, schema.text(defaultText));
        let tr;
        if ((additionalParams?.nodePos !== undefined) && (additionalParams?.textInput !== undefined)) {
            tr = replaceTextRangeWithNode(state, additionalParams.nodePos, additionalParams.nodePos + additionalParams.textInput.length + 1, node);
        } else {
            tr = replaceSelectionParagraphWithNode(state, node, true);
        }

        if (tr !== state.tr) {
            const {$from} = state.selection;
            const textSelection = TextSelection.between(
                tr.doc.resolve(
                    $from.before(),
                ),
                tr.doc.resolve(
                    $from.before() + (node.isTextblock ? node.nodeSize - 1 : 0),
                )
            );

            // Apply this selection to the transaction
            tr.setSelection(textSelection);

            dispatch && dispatch(tr);
            view?.focus();
            return true;
        }
        return false;
    }
}
